<template>
  <div class="grid gap-16">
    <div class="grid gap-8">
      <div class="flex items-center justify-between gap-8">
        <h3 class="raw-cta-2">{{ i18n(translations.amount) }}</h3>
        <!-- 50px = the impact accordions' own inset (16px header padding
                     + 18px chevron + 16px gap), so both sets of circles line up. -->
        <ScoreCircles
          class="me-[50px] [--score-fill:white]"
          :score="info.quantityScore"
        />
      </div>
      <span class="raw-body-3 text-[var(--raw-darkgrey)]">
        {{ i18n(info.quantityLabel) }}
      </span>
    </div>

    <PhoneDiagram :parts="info.parts" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import PhoneDiagram from '~/scopes/campaign/components/UI/PhoneDiagram.vue'
import ScoreCircles from '~/scopes/campaign/components/highlights/metal/ScoreCircles.vue'
import type { SmartphoneInfo } from '~/scopes/campaign/data/metals/types'

import translations from './SmartphoneSection.translations'

// How much of the metal a phone holds, then where it sits. The dissection is shared with
// the journey's opening card, which takes it scoreless.
defineProps<{ info: SmartphoneInfo }>()

const i18n = useI18n()
</script>
